export enum PrescriptionStatusCodes {
  NoStatus = 0,
  TransferredOut = 1,
  PackagedForDelivery = 2,
  Completed = 3,
  Shipped = 4,
  InProcess = 5,
  Delivered = 6,
}
